export const ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY = "grain-saas.route-map-group-ranges-visible";

const ENABLED_STORAGE_VALUE = "1";

let memoryPreferenceValue = false;

const preferenceListeners = new Set();

function getDefaultWindow() {
  return typeof window !== "undefined" ? window : undefined;
}

function getLocalStorage(targetWindow = getDefaultWindow()) {
  try {
    return targetWindow?.localStorage ?? null;
  } catch {
    return null;
  }
}

function emitPreferenceChange() {
  preferenceListeners.forEach((listener) => {
    listener();
  });
}

export function getRouteMapGroupRangePreferenceSnapshot({ targetWindow } = {}) {
  const storage = getLocalStorage(targetWindow);
  if (!storage) {
    return memoryPreferenceValue;
  }

  try {
    memoryPreferenceValue = storage.getItem(ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY) === ENABLED_STORAGE_VALUE;
  } catch {
    // Le cache mémoire garde la préférence active lorsque le stockage est bloqué.
  }

  return memoryPreferenceValue;
}

export function setRouteMapGroupRangePreference(value, { targetWindow } = {}) {
  const nextValue = value === true;
  const storage = getLocalStorage(targetWindow);

  memoryPreferenceValue = nextValue;

  if (storage) {
    try {
      if (nextValue) {
        storage.setItem(ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY, ENABLED_STORAGE_VALUE);
      } else {
        storage.removeItem(ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY);
      }
    } catch {
      // Repli silencieux sur le cache mémoire du module.
    }
  }

  emitPreferenceChange();
  return nextValue;
}

export function subscribeRouteMapGroupRangePreference(onStoreChange, { targetWindow } = {}) {
  if (typeof onStoreChange !== "function") {
    return () => {};
  }

  preferenceListeners.add(onStoreChange);

  const resolvedWindow = targetWindow || getDefaultWindow();
  const handleStorage = (event) => {
    if (event && event.key !== null && event.key !== ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY) {
      return;
    }

    if (event?.key === ROUTE_MAP_GROUP_RANGE_PREFERENCE_STORAGE_KEY) {
      memoryPreferenceValue = event.newValue === ENABLED_STORAGE_VALUE;
    }
    onStoreChange();
  };

  resolvedWindow?.addEventListener?.("storage", handleStorage);

  return () => {
    preferenceListeners.delete(onStoreChange);
    resolvedWindow?.removeEventListener?.("storage", handleStorage);
  };
}
